import { memo as Memo, useMemo, useEffect, useRef } from 'react';
import { gsap } from 'gsap';

//* Helpers
import breakString from '@helpers/breakString';

//* Components
import SubService from './SubService';
import Text from '@/components/global/Text';
import MinTitle from '@components/global/MinTitle';

//* Styles
import SubServicesStyle from './style';

const SubServices = Memo(({ active = true, title, description, items }) => {
	//! Refs
	const topRef = useRef();

	//! Animation
	const tl = useMemo(() => gsap.timeline({ delay: 0.8 }), []);

	useEffect(() => {
		let arr = [];

		// items.map((i, k) => {
		//     return arr.push(topRef.current?.childNodes[1]?.childNodes[k], topRef.current.childNodes[1].childNodes[k].childNodes[0], topRef.current.childNodes[1].childNodes[k].childNodes[1].childNodes[0], topRef.current.childNodes[1].childNodes[k].childNodes[1].childNodes[1])
		// })

		if (active) {
			tl.staggerTo(
				[arr],
				0,
				{
					opacity: 1,
				},
				0.1
			);
		} else {
			tl.staggerTo(
				[arr],
				0,
				{
					opacity: 0,
				},
				0
			);
		}
	}, [active]);

	return (
		<SubServicesStyle
			ref={topRef}
			className={'we_offer_wrapper'}>
			{title ? (
				<MinTitle
					active={active}
					title={breakString(title)}
				/>
			) : null}
			{description ? (
				<div className={'offerDescWrapper'}>
					<Text
						tag={'h4'}
						className={`we_offer_desc h6 font-poppins font-light`}>
						{description}
					</Text>
				</div>
			) : null}
			{items?.length > 0 ? (
				<div className={'offersList'}>
					{items.map((dataItem, idx) => (
						<SubService
							itemNumber={idx}
							title={dataItem.featured_title}
							image={dataItem.featured_image}
							href={`/services/${dataItem.slug}`}
							key={`${dataItem.featured_title}-${idx}`}
							description={dataItem.featured_description}
						/>
					))}
				</div>
			) : null}
		</SubServicesStyle>
	);
});

export default SubServices;
